// extracted by mini-css-extract-plugin
export default {"heading":"_r-z","corrected":"as-z","redirectVerbiageContainer":"bs-z","redirectVerbiageText":"cs-z"};